import React from "react";
import { Shield, Sun, Sparkles, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";
import Section from "./ui/Section";

const Categories = () => {
  const { t } = useTranslation();
  const categories = [
    {
      id: 1,
      title: t("categoriesSection.items.immunity.title"),
      subtitle: t("categoriesSection.items.immunity.subtitle"),
      icon: <Shield className="w-6 h-6" />,
    },
    {
      id: 2,
      title: t("categoriesSection.items.energy.title"),
      subtitle: t("categoriesSection.items.energy.subtitle"),
      icon: <Sun className="w-6 h-6" />,
    },
    {
      id: 3,
      title: t("categoriesSection.items.beauty.title"),
      subtitle: t("categoriesSection.items.beauty.subtitle"),
      icon: <Sparkles className="w-6 h-6" />,
    },
    {
      id: 4,
      title: t("categoriesSection.items.heart.title"),
      subtitle: t("categoriesSection.items.heart.subtitle"),
      icon: <Heart className="w-6 h-6" />,
    },
  ];

  return (
    <section className="py-24 bg-white border-b border-fecos-border/50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">

        {/* Header */}
        <Section className="flex flex-col md:flex-row justify-between items-end mb-16 gap-4">
          <div>
            <span className="text-fecos-accent font-bold text-xs tracking-[0.2em] uppercase block mb-3">
              {t("categoriesSection.header.uptitle")}
            </span>
            <h2 className="text-4xl font-bold text-fecos-text tracking-tight">
              {t("categoriesSection.header.title")}
            </h2>
          </div>

          <p className="text-fecos-gray text-lg max-w-md hidden md:block text-right">
            {t("categoriesSection.header.subtitle")}
          </p>
        </Section>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {categories.map((cat, index) => (
            <Section
              key={cat.id}
              delay={index}
              className="group bg-fecos-bg rounded-[24px] p-8 hover:bg-white hover:shadow-xl hover:scale-[1.02] transition-all duration-500 cursor-pointer border border-transparent hover:border-fecos-border/50"
            >
              <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center mb-6 text-fecos-text group-hover:bg-fecos-accent group-hover:text-white transition-colors duration-500 shadow-sm">
                {cat.icon}
              </div>

              <h3 className="text-xl font-bold text-fecos-text mb-2">
                {cat.title}
              </h3>

              <p className="text-fecos-gray text-sm leading-relaxed group-hover:text-fecos-text/70 transition-colors">
                {cat.subtitle}
              </p>
            </Section>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
